<template>
  <section class="integration-detail">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="detail-card">
            <img
              src="@/assets/mainImages/spiris.png"
              alt="Spiris"
              class="integration-logo"
            />

            <h1>{{ $t("IntegrationPages.Spiris.Title") }}</h1>
            <p class="subtitle">{{ $t("IntegrationPages.Spiris.Subtitle") }}</p>

            <ul class="points">
              <li>{{ $t("IntegrationPages.Spiris.Point1") }}</li>
              <li>{{ $t("IntegrationPages.Spiris.Point2") }}</li>
              <li>{{ $t("IntegrationPages.Spiris.Point3") }}</li>
            </ul>

            <div class="actions">
              <router-link
                :to="{
                  name: 'signup',
                  query: { accounting_system: 'spiris' },
                }"
                class="primary-btn"
              >
                {{ $t("IntegrationPages.Common.StartNow") }}
              </router-link>
              <router-link :to="{ name: 'home' }" class="secondary-btn">
                {{ $t("IntegrationPages.Common.BackHome") }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "IntegrationSpiris",
};
</script>

<style lang="scss" scoped>
.integration-detail {
  padding: 70px 0;
  background: linear-gradient(180deg, #f8fcff 0%, #eef7f4 100%);
}

.detail-card {
  background-color: #fff;
  border-radius: 22px;
  box-shadow: 0 18px 45px rgba(7, 31, 56, 0.12);
  padding: 36px 30px;
}

.integration-logo {
  width: 100%;
  max-height: 90px;
  object-fit: contain;
  margin-bottom: 24px;
}

h1 {
  margin: 0 0 12px 0;
  color: #1a232d;
  font-weight: 700;
  font-size: 34px;
}

.subtitle {
  color: #334155;
  line-height: 1.65;
  margin-bottom: 20px;
}

.points {
  margin: 0;
  padding-left: 20px;
  color: #1f2937;
}

.points li {
  margin-bottom: 10px;
}

.actions {
  margin-top: 26px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.primary-btn,
.secondary-btn {
  border-radius: 10px;
  padding: 10px 16px;
  text-decoration: none;
  font-weight: 600;
}

.primary-btn {
  background-color: #045e62;
  color: #fff;
}

.secondary-btn {
  background-color: #e2e8f0;
  color: #0f172a;
}

@media (max-width: 576px) {
  .detail-card {
    padding: 26px 20px;
  }

  h1 {
    font-size: 28px;
  }
}

body.dark-layout .integration-detail .detail-card {
  background-color: #0f172a;
  border: 1px solid #334155;
}

body.dark-layout .integration-detail h1 {
  color: #f8fafc;
}

body.dark-layout .integration-detail .subtitle {
  color: #cbd5e1;
}

body.dark-layout .integration-detail .points {
  color: #e2e8f0;
}

body.dark-layout .integration-detail .secondary-btn {
  background-color: #334155;
  color: #f8fafc;
}
</style>
